document.addEventListener("DOMContentLoaded", function () {
	// Ensure jQuery and Slick are loaded before running
	let SLIDES_TO_SHOW = 5.3;
	var $mainSlider = $(".ok--main-slider");
	var $navSlider = $(".ok--nav-slider");

	function adjustNavPeek(targetSlide, slick, instant) {
		let slideWidth = slick.$slideTrack
			.find(".slick-slide")
			.first()
			.outerWidth(true);
		let $track = slick.$slideTrack;

		let maxSlideIndex = Math.ceil(
			slick.slideCount - slick.options.slidesToShow,
		);

		if (instant) {
			$track.css("transition", "none");
		} else {
			$track.css("transition", "margin-left 0.3s ease");
		}

		if (targetSlide === 0) {
			$track.css("margin-left", "0px");
		} else if (targetSlide >= maxSlideIndex) {
			$track.css("margin-left", "0px");
		} else {
			$track.css("margin-left", slideWidth * 0.5 + "px");
		}
	}

	$navSlider.on("init", function (e, slick) {
		adjustNavPeek(0, slick, true);
	});

	// Initial Slide Count setup before init
	$mainSlider.on("init", function (event, slick) {
		$(".ok--count-current").text(1);
		$(".ok--count-total").text(slick.slideCount);
		updateButtonStates(0, slick.slideCount);
	});

	// Initialize Main Slider
	$mainSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: true,
		asNavFor: ".ok--nav-slider",
		infinite: false,
		waitForAnimate: false,
		adaptiveHeight: true,
	});

	//  Initialize Nav Slider
	$navSlider.slick({
		slidesToShow: SLIDES_TO_SHOW,
		slidesToScroll: 1,
		asNavFor: ".ok--main-slider",
		dots: false,
		arrows: false,
		focusOnSelect: true,
		infinite: false,
		waitForAnimate: false,
		centerMode: false,
		responsive: [
			{ breakpoint: 1024, settings: { slidesToShow: 4.3 } },
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2.2,
					slidesToScroll: 1,
					centerMode: false,
					infinite: false,
				},
			},
		],
	});

	$navSlider.on("beforeChange", function (e, slick, currentSlide, nextSlide) {
		adjustNavPeek(nextSlide, slick, false);
	});

	$mainSlider.on(
		"beforeChange",
		function (e, slick, currentSlide, nextSlide) {
			let navSlick = $navSlider.slick("getSlick");
			adjustNavPeek(nextSlide, navSlick, false);
		},
	);

	$navSlider.on("breakpoint", function (e, slick) {
		SLIDES_TO_SHOW = slick.options.slidesToShow;
		adjustNavPeek(slick.currentSlide, slick, true);
	});

	// Update counters and buttons on slide change
	$mainSlider.on("afterChange", function (event, slick, currentSlide) {
		$(".ok--count-current").text(currentSlide + 1);
		updateButtonStates(currentSlide, slick.slideCount);
	});

	// Custom Navigation Bindings
	$(".ok--btn-prev").on("click", function () {
		if (!$(this).hasClass("ok--disabled")) {
			$mainSlider.slick("slickPrev");
		}
	});

	$(".ok--btn-next").on("click", function () {
		if (!$(this).hasClass("ok--disabled")) {
			$mainSlider.slick("slickNext");
		}
	});

	// Helper function to manage disabled button states
	function updateButtonStates(currentSlide, totalSlides) {
		console.log(
			"Updating button states: currentSlide=" +
				currentSlide +
				", totalSlides=" +
				totalSlides,
		);
		if (currentSlide === 0) {
			$(".ok--btn-prev").addClass("ok--disabled");
		} else {
			$(".ok--btn-prev").removeClass("ok--disabled");
		}

		if (currentSlide === totalSlides - 1) {
			$(".ok--btn-next").addClass("ok--disabled");
		} else {
			$(".ok--btn-next").removeClass("ok--disabled");
		}
	}

	$("#accordionSec5").on("show.bs.collapse", function (e) {
		var $activeCard = $(e.target).closest(".ok--sec5-card");

		var newImageSrc = $activeCard.data("image");

		if (newImageSrc) {
			var $dynamicImg = $("#ok--sec5-dynamic-img");

			$dynamicImg.fadeOut(250, function () {
				$(this).attr("src", newImageSrc).fadeIn(250);
			});
		}

		$(".ok--sec5-card").css("border", "1px solid #e2e8f0"); 
		$activeCard.css("border", "2px solid #1f4fc9"); 
	});

	$(".ok--sec5-card").first().css("border", "2px solid #1f4fc9");

	/* ─── Countdown Timer  */
	var INITIAL_SECONDS = 85632; 
	var remaining = INITIAL_SECONDS;

	function pad(n) {
		return String(n).padStart(2, "0");
	}

	function updateCountdowns() {
		var h = Math.floor(remaining / 3600);
		var m = Math.floor((remaining % 3600) / 60);
		var s = remaining % 60;

		// Announce bar countdown
		var elH = document.getElementById("cd-h");
		var elM = document.getElementById("cd-m");
		var elS = document.getElementById("cd-s");
		if (elH) elH.textContent = pad(h);
		if (elM) elM.textContent = pad(m);
		if (elS) elS.textContent = pad(s);

		// Final section countdown
		var fH = document.getElementById("final-cd-h");
		var fM = document.getElementById("final-cd-m");
		var fS = document.getElementById("final-cd-s");
		if (fH) fH.textContent = pad(h);
		if (fM) fM.textContent = pad(m);
		if (fS) fS.textContent = pad(s);

		if (remaining > 0) remaining--;
	}

	updateCountdowns();
	setInterval(updateCountdowns, 1000);



     var stickyBar = document.querySelector('.ok--floating-bar');

	if (stickyBar) {
		window.addEventListener(
		"scroll",
		function () {
			stickyBar.style.display = window.scrollY > 600 ? "" : "none";
		},
		{ passive: true }
		);
	}

	 const revealElements = document.querySelectorAll('.reveal-up');

    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('reveal-active');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15, // Triggers when 15% of the element is visible
        rootMargin: "0px 0px -50px 0px" 
    });
    revealElements.forEach(el => {
        revealObserver.observe(el);
    });
});
